import React, { useEffect } from "react";
import NavigationComponent from "../calendar/components/NavigationComponent";
import { AthleteLinks } from "../../../parts/athlete-links";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import getAvatarUrl from "../../../utils/get-avatar-url";

export const ReportsMenu = ({ locals }) => {
  const { query, pathname, athlete } = locals;

  // This menu only exists on mobile (all of its content is only-show-mobile).
  // On wider screens, send the user to the same page the desktop Reports link
  // opens, keeping the query string (athlete, organizationCoach, ...).
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(max-width: 640px)").matches) return;
    window.location.replace(
      `/athlete-portal/metrics/exercise-history${window.location.search}`
    );
  }, []);

  return (
    <>
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals.athlete)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        textKey="nav.reportsMenu"
        pathName={pathname}
        classNames="only-show-mobile"
      />
    </>
  );
};
